<template>
    <div style="background:#efefef; border-radius:10px; padding-left:10px;border:1px solid silver;">
        <OpenLink :Editor="Editor"></OpenLink>
        <EditLink :Editor="Editor"></EditLink>
    </div>
</template>
<script>

import OpenLink from '@/views/components/atoms/tiptap/Predefined/Buttons/Links/OpenLink.vue';
import EditLink from '@/views/components/atoms/tiptap/Predefined/Buttons/Links/EditLink.vue';

export default ({
    components: {
        OpenLink,
        EditLink
    },
    props: ["Editor"]
});
</script>